import { render, staticRenderFns } from "./8.vue?vue&type=template&id=88542fa8&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88542fa8",
  null
  
)

export default component.exports